import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export interface PromptLibraryItem {
    type: string,
    subType: string,
    title: string,
    promptContent: string,
    id: string,
    createdAt: string,
    isDeleted: boolean,
    allowAnonymous?: boolean
    isPro:  boolean,
    contentLength: number,
};

interface PromptLibrary {
    promptLibraryItems: PromptLibraryItem[],
    selectedPromptLibrary:PromptLibraryItem,
}

const initialState : PromptLibrary = {
    promptLibraryItems: [],
    selectedPromptLibrary: {
        type:''
        ,subType:''
        ,title:'',
        promptContent:'',
        id:'',
        createdAt:'',
        isDeleted:false,
        isPro:false,
        contentLength:0},
}

const PromptLibraryStore = createSlice({
    name: 'PromptLibrary',
    initialState: initialState,
    reducers: {
        setPromptLibraryItems: (state , action:PayloadAction<PromptLibraryItem[]>) => {
            state.promptLibraryItems = action.payload;
        },
        setSelectedPromptLibrary: (state , action:PayloadAction<PromptLibraryItem>) => {
            state.selectedPromptLibrary = action.payload;
        }
    }
})

export const {
    setPromptLibraryItems,
    setSelectedPromptLibrary
} = PromptLibraryStore.actions
export default PromptLibraryStore.reducer